// Export CSS class names for type safety
export const baseCard = "base-card";
export const interactiveCard = "base-card interactive-card";
export const staticCard = "base-card static-card";

export const chip = "chip";

export const primaryButton = "btn-base primary-button";
export const secondaryButton = "btn-base secondary-button";
export const dangerButton = "btn-base danger-button";
export const plusBtn = "btn-base plus-btn";
export const closeButton = "btn-base close-button";
export const inputField = "input-field";

export const sectionTitle = "section-title";
export const labelText = "label-text";
export const labelCls = "label-cls";

// Utility class combinations
export const flexCenter = "flex items-center justify-center";
export const flexBetween = "flex items-center justify-between";
export const flexCol = "flex flex-col";
export const flexColCenter = "flex flex-col items-center";